export default __webpack_public_path__ + "static/media/id-back.0562f78a.jpg";